if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      initMobileNav() {
        if (this.classList.contains('complementary-products')) return;
        const grid = this.querySelector('.products-grid-wrap');
        if (!grid) return;

        const prevBtn = this.querySelector('.swiper-button-prev');
        const nextBtn = this.querySelector('.swiper-button-next');

        const updateButtons = () => {
          if (window.innerWidth >= 768) return;
          const atStart = grid.scrollLeft <= 0;
          const atEnd = Math.ceil(grid.scrollLeft + grid.clientWidth) >= grid.scrollWidth;
          prevBtn?.toggleAttribute('disabled', atStart);
          prevBtn?.setAttribute('aria-disabled', atStart);
          nextBtn?.toggleAttribute('disabled', atEnd);
          nextBtn?.setAttribute('aria-disabled', atEnd);
        };

        prevBtn?.addEventListener('click', () => {
          if (window.innerWidth < 768) {
            const colWidth = grid.querySelector('.f-column')?.offsetWidth || grid.offsetWidth;
            grid.scrollBy({ left: -colWidth, behavior: 'smooth' });
          }
        });

        nextBtn?.addEventListener('click', () => {
          if (window.innerWidth < 768) {
            const colWidth = grid.querySelector('.f-column')?.offsetWidth || grid.offsetWidth;
            grid.scrollBy({ left: colWidth, behavior: 'smooth' });
          }
        });

        grid.addEventListener('scroll', updateButtons);
        updateButtons();
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              
              if (window.wimSetupWishlistElements) {
                window.wimSetupWishlistElements();
              }

              this.initMobileNav();
              this.dispatchEvent(new CustomEvent('recommendations:loaded', {
                bubbles: true,
                detail: {
                  sectionId: this.dataset.id,
                  productId: this.dataset.productId
                }
              }));
            } else if (recommendations) {
              if (recommendations.classList.contains('complementary-products')) {
                this.closest('.product__block').remove();
              } else {
                this.closest('.shopify-section').remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
}
